export default {
	location: {
		options: [
			{
				label: "Portugal",
				id: "PORTUGAL",
			},
			{
				label: "Espanha",
				id: "SPAIN",
			},
			{
				label: "Alemanha",
				id: "GERMANY",
			},
			{
				label: "Outro",
				id: "OTHER",
			},
		],
	},

	type: {
		options: [
			{ id: "ROOF", label: "Cobertura" },
			{ id: "FACADE", label: "Fachada" },
			{ id: "GENERAL", label: "Geral" },
		],
	},

	profileType: {
		options: [
			{ id: "OMEGA", label: "Ω" },
			{ id: "C", label: "C" },
			{ id: "Z", label: "Z" },
		],
	},

	profileOrientation: {
		options: [
			{ id: "HORIZONTAL", label: "Horizontal" },
			{ id: "VERTICAL", label: "Vertical" },
		],
	},

	profileFormat: {
		options: [
			{ id: "MAJOR_AXIS_BENDING_REGULAR", label: ">" },
			{ id: "MAJOR_AXIS_BENDING_INVERTED", label: "<" },
		],
	},

	supportWidth: {
		options: [
			{ id: "LESS_THAN_135", label: "< 135mm" },
			{ id: "BETWEEN_135_AND_200", label: ">= 135mm e < 200mm" },
			{ id: "MORE_THAN_200", label: "> 200mm" },
		],
	},

	liveDistributedDeltaCfg: {
		options: [
			{
				label: "Categoria H: coberturas",
				id: "category_h",
				deltas: [0, 0, 0],
			},
			{
				label: "Definido pelo utilizador",
				id: "customized",
				deltas: [0, 0, 0],
			},
		],
	},

	windDeltasCfg: {
		options: [
			{
				id: "en1991-1-4",
				label: "EN 1991-1-4",
				deltas: [0.6, 0.2, 0],
			},
			{
				id: "customized",
				label: "Definido pelo utilizador",
				deltas: [0, 0, 0],
			},
		],
	},

	snowDeltasCfg: {
		options: [
			{
				id: "h<=1000m",
				label: "H<=1000m",
				deltas: [0.5, 0.2, 0],
			},
			{
				id: "h>1000m",
				label: "H>1000m",
				deltas: [0.7, 0.5, 0.2],
			},
			{
				id: "customized",
				label: "Customizado",
				deltas: [0, 0, 0],
			},
		],
	},

	combination: {
		options: [
			{
				id: "CHARACTERISTIC",
				label: "Característica",
			},
			{
				id: "FREQUENT",
				label: "Frequente",
			},
			{
				id: "QUASI_PERMANENT",
				label: "Quase permanente",
			},
		],
	},

	axialLoadTypes: {
		options: [
			{
				id: "DESIGN",
				label: "Carga axial de dimensionamento",
			},
			{
				id: "UNFACTORED_WIND",
				label: "Carga axial não majorada devido à acção do vento",
			},
		],
	},

	direction: {
		options: [
			{
				id: "TRACTION",
				label: "Tração",
			},
			{
				id: "COMPRESSIONS",
				label: "Compressão",
			},
		],
	},

	upperFibre: {
		options: [
			{
				id: 0,
				label: "Fibra superior contraventada pelo painel/chapa",
			},
			{
				id: 1,
				label: "Número de travamentos laterais",
			},
		],
	},

	steel: {
		options: [
			{ id: "S280", label: "S280" },
			{ id: "S350", label: "S350" },
		],
	},
};
